<script>
import { mergeData } from 'vue-functional-data-merge';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
const VEntry = () => import('./Entry');

export default {
  name: 'DescriptionListEntryDate',

  functional: true,

  props: {
    dateFormat: {
      type: String,
      required: false,
      default: 'auto',
    },

    date: {
      type: Boolean,
      required: false,
    },

    dateTime: {
      type: Boolean,
      required: false,
    },

    unformatted: {
      type: Boolean,
      required: false,
    },
  },

  render(h, { props, data, children, parent }) {
    const componentData = {
      scopedSlots: {},
    };

    if (!props.unformatted) {
      componentData.scopedSlots.default = ({ value }) => {
        let dateFormat = props.dateFormat;
        if (props.date) dateFormat = 'date';
        if (props.dateTime) dateFormat = 'dateTime';

        if (dateFormat && value) {
          try {
            const date = parseISO(value);
            if (dateFormat === 'auto') {
              dateFormat = value.indexOf(':') !== -1 ? 'dateTime' : 'date';
            }
            return format(date, parent.$t(`common.${dateFormat}Format`));
          } catch (e) {
            if (e instanceof RangeError) {
              return value;
            } else {
              return '';
            }
          }
        }
      };
    }

    return h(VEntry, mergeData(data, componentData), children);
  },
};
</script>
